import { axiosV3 } from "../../../Utils/Axios/axiosV3";

export const getBudgetItemsService = async (userToken: string) => {
  return axiosV3.get("/get-budget", {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
